/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { WhseJob1501IndexTypes } from './Actions';
import INITIAL_STATE from './InitialState';

export const whseJob1501IndexResetTimestamp = (
  state,
  { currentPage, sorts, filters, pageSize }
) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now(),
  // selectedDocuments: INITIAL_STATE.selectedDocuments,
  fetchIsLoading: false
});

export const whseJob1501IndexFetchWhseJob1501IndexLoading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const whseJob1501IndexFetchWhseJob1501IndexSuccess = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const whseJob1501IndexAddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ].slice(0, 5)
  };
};

export const whseJob1501IndexRemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const whseJob1501IndexSetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [WhseJob1501IndexTypes.WHSE_JOB1501_INDEX_RESET_TIMESTAMP]: whseJob1501IndexResetTimestamp,
  [WhseJob1501IndexTypes.WHSE_JOB1501_INDEX_FETCH_WHSE_JOB1501_INDEX_LOADING]: whseJob1501IndexFetchWhseJob1501IndexLoading,
  [WhseJob1501IndexTypes.WHSE_JOB1501_INDEX_FETCH_WHSE_JOB1501_INDEX_SUCCESS]: whseJob1501IndexFetchWhseJob1501IndexSuccess,
  [WhseJob1501IndexTypes.WHSE_JOB1501_INDEX_ADD_SELECTED_DOCUMENTS]: whseJob1501IndexAddSelectedDocuments,
  [WhseJob1501IndexTypes.WHSE_JOB1501_INDEX_REMOVE_SELECTED_DOCUMENTS]: whseJob1501IndexRemoveSelectedDocuments,
  [WhseJob1501IndexTypes.WHSE_JOB1501_INDEX_SET_WORKSPACE_VISIBLE]: whseJob1501IndexSetWorkspaceVisible
});
